import { gql } from '@apollo/client'

export const MARK_NOTIFICATION_UNREAD_MUTATION = gql`
  mutation markNotificationUnread($id: ID!) {
    markNotificationUnread(id: $id) {
      notification {
        id
        read
        readAt
      }
      errors
    }
  }
`
